import {
  CLEAR_DEAL_IN_RESULTS,
  CLEAR_DEAL_EVALUATION,
  GET_DEAL_EVALUATION,
  GET_DEAL_EVALUATION_SUCCESS,
  GET_DEAL_EVALUATION_FAIL,
  IDealEvaluationState,
  ISummaryDeal,
  SET_DEAL_IN_RESULTS,
  SET_FORECAST_TYPE,
  SET_COST_FORMULA_TYPE,
  SET_IS_STALE,
  EForecastEvaluationType,
  EEvaluationUnit,
  SET_EVALUATION_UNIT,
  SET_CURRENT_EVALUATION_UNIT,
  ECostFormulaParamType,
} from 'store/deal-evaluation/types';
import { IDeal } from 'store/deals/types';
import { getCachedValue, EStorageField } from 'lib/storage';

const buildInitialState = (): IDealEvaluationState => ({
  loading: false,
  error: null,
  [EForecastEvaluationType.IHS]: null,
  [EForecastEvaluationType.SHELL]: null,
  deal: null,
  isStale: false,
  selectedForecastType:
    (getCachedValue(EStorageField.FORECAST) as EForecastEvaluationType) || EForecastEvaluationType.IHS,
  selectedUnitType: (getCachedValue(EStorageField.EVALUATION_UNIT) as EEvaluationUnit) || EEvaluationUnit.TON,
  selectedCostFormulaType:
    (getCachedValue(EStorageField.COST_FORMULA) as ECostFormulaParamType) || ECostFormulaParamType.ITP,
  selectedFormulaIndex: 0,
  selectedCurrentUnitType: EEvaluationUnit.TON,
});

interface IActionClearDealEvaluation {
  type: typeof CLEAR_DEAL_EVALUATION;
}

interface IActionGetDealEvaluation {
  type: typeof GET_DEAL_EVALUATION;
}

interface IActionGetDealEvaluationFail {
  type: typeof GET_DEAL_EVALUATION_FAIL;
  error: Error;
}

interface IActionGetDealEvaluationSuccess {
  type: typeof GET_DEAL_EVALUATION_SUCCESS;
  [EForecastEvaluationType.IHS]: ISummaryDeal;
  [EForecastEvaluationType.SHELL]: ISummaryDeal;
}

interface IActionSetDealInResults {
  type: typeof SET_DEAL_IN_RESULTS;
  deal: IDeal | null;
}

interface IActionClearDealInResults {
  type: typeof CLEAR_DEAL_IN_RESULTS;
}

interface IActionSetIsStale {
  type: typeof SET_IS_STALE;
  isStale: boolean;
}

interface IActionSetForecastType {
  type: typeof SET_FORECAST_TYPE;
  selectedForecastType: EForecastEvaluationType;
}

interface IActionSetCostFormulaType {
  type: typeof SET_COST_FORMULA_TYPE;
  selectedCostFormulaType: ECostFormulaParamType;
}

interface IActionSetEvaluationUnit {
  type: typeof SET_EVALUATION_UNIT;
  selectedUnitType: EEvaluationUnit;
}

interface IActionSetCurrentEvaluationUnit {
  selectedCurrentUnit: string;
  type: typeof SET_CURRENT_EVALUATION_UNIT;
  selectedCurrentUnitType: string;
}

type TAction =
  | IActionClearDealEvaluation
  | IActionGetDealEvaluation
  | IActionGetDealEvaluationFail
  | IActionGetDealEvaluationSuccess
  | IActionSetDealInResults
  | IActionClearDealInResults
  | IActionSetIsStale
  | IActionSetForecastType
  | IActionSetCostFormulaType
  | IActionSetEvaluationUnit
  | IActionSetCurrentEvaluationUnit;

export default (state = buildInitialState(), action: TAction) => {
  switch (action.type) {
    case CLEAR_DEAL_EVALUATION: {
      return buildInitialState();
    }

    case CLEAR_DEAL_IN_RESULTS: {
      return {
        ...state,
        deal: null,
      };
    }

    case GET_DEAL_EVALUATION: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }

    case GET_DEAL_EVALUATION_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }

    case GET_DEAL_EVALUATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        [EForecastEvaluationType.IHS]: action[EForecastEvaluationType.IHS],
        [EForecastEvaluationType.SHELL]: action[EForecastEvaluationType.SHELL],
      };
    }

    case SET_DEAL_IN_RESULTS: {
      return {
        ...state,
        deal: action.deal,
      };
    }

    case SET_IS_STALE: {
      return {
        ...state,
        isStale: action.isStale,
      };
    }

    case SET_FORECAST_TYPE: {
      return {
        ...state,
        selectedForecastType: action.selectedForecastType,
      };
    }

    case SET_COST_FORMULA_TYPE: {
      return {
        ...state,
        selectedCostFormulaType: action.selectedCostFormulaType,
      };
    }

    case SET_EVALUATION_UNIT: {
      return {
        ...state,
        selectedUnitType: action.selectedUnitType,
      };
    }
    case SET_CURRENT_EVALUATION_UNIT: {
      return {
        ...state,
        selectedCurrentUnitType: action.selectedCurrentUnit,
      };
    }

    default: {
      return state;
    }
  }
};
